import { SxProps, Theme } from '@mui/material/styles';

export const DAY_LABEL_FORMAT = 'ccc d MMMM yyyy';

export const DAY_BUTTON_SX: SxProps<Theme> = {
  '&.MuiButton-textSizeSmall': {
    minWidth: { xs: 'auto', sm: '210px' },
    px: 1,
    fontWeight: 400,
  },
};
